import React, {useEffect} from 'react'

import {ThemeProvider} from 'styled-components'
import Script from 'next/script'

import {theme} from '@miro-site/design-tokens'
import {checkUserInfo, GlobalStyle} from '@miro-site/core'

import {getAnalytics} from '@miro-site/analytics'
import {TemplateOpenerProvider} from '@miro-site/core'
import {SplitIoProvider} from '@miro-site/splitio'

import useHotJar from '../src/hooks/useHotjar'

import '../public/assets/styles/components-twig.css'
import '../public/assets/styles/one-trust-cookie-banner.css'

function MyApp({Component, pageProps}) {
  useEffect(() => {
    handleLegacyInit()
  }, [])

  const handleLegacyInit = async () => {
    const initLegacy = (await import('@miro-site/components-twig')).initLegacy
    initLegacy()
  }

  useEffect(() => {
    async function trackPageView() {
      await getAnalytics()

      if (typeof window.analytics !== 'undefined') {
        window.analytics.page()

        const userInfo = checkUserInfo() || {}

        if (userInfo.id) {
          window.analytics.identify(userInfo.id)
        }
      }
    }

    // Temprorary disable analytics for testing puproses
    if (window.location.pathname !== '/my-new-awesome-page/') {
      trackPageView()
    }
  }, [])

  if (process.env.NEXT_PUBLIC_HOTJAR_ID) {
    const hotJarId = +process.env.NEXT_PUBLIC_HOTJAR_ID
    const hotJarVersion = +process.env.NEXT_PUBLIC_HOTJAR_VERSION || 6
    const hotJarDebugMode = !!process.env.NEXT_PUBLIC_HOTJAR_DEBUG_MODE

    if (hotJarId) {
      useHotJar(hotJarId, hotJarVersion, hotJarDebugMode)
    }
  }

  const content = (
    <>
      <TemplateOpenerProvider getAnalytics={getAnalytics}>
        <ThemeProvider
          theme={{
            ...theme,
            multipliers: {
              ...theme.multipliers,
              large: value => `${value}px`,
            },
          }}
        >
          <Script strategy="beforeInteractive" src="/scripts/optanonWrapper.js" />

          <Script
            src="https://cdn.cookielaw.org/consent/4133a0ef-6999-461d-909d-24f2b05bbc15/otSDKStub.js"
            data-document-language="true"
            charSet="UTF-8"
            data-domain-script="4133a0ef-6999-461d-909d-24f2b05bbc15"
            strategy="beforeInteractive"
          />

          <Script strategy="beforeInteractive" src="/scripts/wistiaCustomEvent.js" />

          <GlobalStyle />
          <Component {...pageProps} />
        </ThemeProvider>
      </TemplateOpenerProvider>
    </>
  )

  if (process.env.NEXT_PUBLIC_SPLITIO_CLIENT_KEY) {
    return (
      <SplitIoProvider
        authorizationKey={process.env.NEXT_PUBLIC_SPLITIO_CLIENT_KEY}
        getAnalytics={getAnalytics}
      >
        {content}
      </SplitIoProvider>
    )
  }

  return content
}

export default MyApp
